import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { listar, COLECOES } from '../../services/firestore';
import styles from './Cadastros.module.css';

const CARDS = [
  {
    id: 'produtos',
    titulo: 'Produtos',
    icone: '🎨',
    cor: 'produtos',
    rota: '/cadastros/produtos',
    descricao: 'Tintas, solventes e revestimentos',
    singular: 'cadastrado',
    plural: 'cadastrados',
    ativo: true,
  },
  {
    id: 'estoques',
    titulo: 'Estoques',
    icone: '📦',
    cor: 'estoques',
    rota: '/cadastros/estoques',
    descricao: 'Locais físicos de armazenamento',
    singular: 'local',
    plural: 'locais',
    ativo: true,
  },
  {
    id: 'resinas',
    titulo: 'Resinas',
    icone: '🧪',
    cor: 'resinas',
    rota: '/cadastros/resinas',
    descricao: 'Epóxi, PU, Esmalte e outros',
    singular: 'tipo',
    plural: 'tipos',
    ativo: true,
  },
  {
    id: 'clientes',
    titulo: 'Clientes',
    icone: '🏭',
    cor: 'clientes',
    rota: '/cadastros/clientes',
    descricao: 'Empresas atendidas com áreas',
    singular: 'empresa',
    plural: 'empresas',
    ativo: true,
  },
  {
    id: 'usuarios',
    titulo: 'Usuários',
    icone: '👤',
    cor: 'usuarios',
    rota: '/cadastros/usuarios',
    descricao: 'Pessoas com acesso ao sistema',
    singular: 'ativo',
    plural: 'ativos',
    ativo: true,
  },
];

export default function Cadastros() {
  const navigate = useNavigate();
  const [contadores, setContadores] = useState({});
  const [carregando, setCarregando] = useState(true);

  useEffect(() => {
    async function carregar() {
      const resultados = await Promise.allSettled([
        listar(COLECOES.PRODUTOS),
        listar(COLECOES.ESTOQUES),
        listar(COLECOES.RESINAS),
        listar(COLECOES.CLIENTES),
        listar(COLECOES.USUARIOS),
      ]);

      const [produtos, estoques, resinas, clientes, usuarios] = resultados;

      setContadores({
        produtos: produtos.status === 'fulfilled' ? produtos.value.length : 0,
        estoques: estoques.status === 'fulfilled' ? estoques.value.length : 0,
        resinas: resinas.status === 'fulfilled' ? resinas.value.length : 0,
        clientes: clientes.status === 'fulfilled' ? clientes.value.length : 0,
        usuarios:
          usuarios.status === 'fulfilled'
            ? usuarios.value.filter((u) => u.ativo !== false).length
            : 0,
      });
      setCarregando(false);
    }

    carregar();
  }, []);

  function handleClick(card) {
    if (card.ativo) {
      navigate(card.rota);
    } else {
      alert(`O cadastro de ${card.titulo} está em desenvolvimento.`);
    }
  }

  return (
    <>
      <div className={styles.topbar}>
        <div className={styles.pageTitle}>Cadastros</div>
      </div>

      <div className={styles.hubGrid}>
        {CARDS.map((card) => {
          const n = contadores[card.id] ?? 0;
          return (
            <div
              key={card.id}
              className={`${styles.hubCard} ${!card.ativo ? styles.indisponivel : ''}`}
              onClick={() => handleClick(card)}
            >
              <div className={`${styles.hubIcon} ${styles[`hi_${card.cor}`]}`}>
                {card.icone}
              </div>
              <div className={styles.hubTitulo}>{card.titulo}</div>
              <div className={styles.hubCount}>
                {carregando ? (
                  <strong>...</strong>
                ) : (
                  <>
                    <strong>{n}</strong> {n === 1 ? card.singular : card.plural}
                  </>
                )}
              </div>
              <div className={styles.hubDesc}>{card.descricao}</div>
              {!card.ativo && (
                <div className={styles.emBreve}>Em desenvolvimento</div>
              )}
            </div>
          );
        })}
      </div>
    </>
  );
}
